var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.666L1.334 24l3.977-3.985-1.326-1.326L0 22.666zm3.985-6.629L2.66 14.711 0 17.363l1.334 1.326 2.651-2.652zm1.326 6.63L6.637 24l2.652-2.66-1.326-1.325-2.652 2.651zm9.797-15.1a.938.938 0 101.325 1.325.938.938 0 00-1.325-1.325zM23.062 0c-.232 0-5.724.033-8.617 2.926l-3.187 3.187a4.655 4.655 0 00-2.585-.776c-1.253 0-2.43.487-3.315 1.373L3.37 8.697l3.978 3.978-2.652 2.651 3.978 3.978 2.651-2.652 3.978 3.978 1.989-1.989a4.657 4.657 0 001.372-3.315c0-.933-.27-1.825-.776-2.585l3.187-3.187C23.967 6.662 24 1.17 24 .938V0h-.938zM7.348 10.024L6.02 8.698l.663-.663a2.794 2.794 0 011.989-.823c.426 0 .839.094 1.213.273l-2.54 2.54zm1.326 6.63l-1.326-1.327 1.326-1.325 1.325 1.325-1.325 1.326zm7.292.662l-.663.663-1.326-1.326 2.539-2.539c.179.374.273.787.273 1.213 0 .752-.292 1.458-.823 1.99zm3.783-9.086l-7.098 7.097-3.977-3.977 7.098-7.098c.22-.22.464-.42.724-.602l3.855 3.855c-.182.26-.382.504-.602.725zm1.5-2.478l-3-3c1.397-.526 2.877-.737 3.821-.821-.084.945-.295 2.424-.82 3.821z",
    fill: "url(#rocket_svg__paint0_linear_1839_60200)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket_svg__paint0_linear_1839_60200",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1393BC"
  })))));
}

export default __webpack_public_path__ + "./fonts/rocket.4c3e8d397e714089d9c3ee906e7b903b.svg";
export { SvgRocket as ReactComponent };